import { createSlice } from "@reduxjs/toolkit";
import { bookingSettingsInitialState } from "./booking-settings.models";
import { fetchBookingSettings, saveBookingSettings } from "./booking-settings.thunk";

const bookingSettingsSlice = createSlice({
  name: "bookingSettings",
  initialState: bookingSettingsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookingSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookingSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchBookingSettings.rejected, (state, action) => {
        state.loading = false;
        state.data = null;
        state.error = action.payload ?? "Failed to load booking settings";
      })
      .addCase(saveBookingSettings.pending, (state) => {
        state.saving = true;
        state.saveError = null;
      })
      .addCase(saveBookingSettings.fulfilled, (state, action) => {
        state.saving = false;
        state.data = action.payload.data;
      })
      .addCase(saveBookingSettings.rejected, (state, action) => {
        state.saving = false;
        state.saveError = action.payload ?? "Failed to save booking settings";
      });
  },
});

export default bookingSettingsSlice.reducer;
